import React, { useCallback, useEffect, useState } from 'react';
import { GeckoFields, GECKO_UTILS, GECKO_CONSTS } from 'ui';
import 'react-phone-number-input/style.css';
import TwilioChannelForm from './TwilioChannelForm';
import Loader from 'components/Loader';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';

const WABA_ID_KEY = 'configuration.waba_id';

const WhatsAppChannelForm = (props) => {
  const [fetchingWabaId, setFetchingWabaId] = useState(false);
  const [wabaIdFetchError, setWabaIdFetchError] = useState(false);

  const fetchWabaId = useCallback(() => {
    setFetchingWabaId(true);
    GeckoRequest.get('/account/waba_id')
      .then((waba_id) => {
        console.log(waba_id);
        changeHandler(WABA_ID_KEY, waba_id);
      })
      .catch((err) => {
        renderError(err);
        setWabaIdFetchError(true);
      })
      .finally(() => setFetchingWabaId(false));
  }, []);

  useEffect(() => {
    fetchWabaId();
  }, []);

  const changeHandler = (key, value) => {
    const newValue = GECKO_UTILS.setNestedValue(props.value, key, value);
    props.onChange(newValue);
  };

  const embeddedSignupInfoListener = (event) => {
    if (!event.origin.endsWith('facebook.com')) return;
    try {
      const data = JSON.parse(event.data);
      if (data.type === 'WA_EMBEDDED_SIGNUP') {
        // if user finishes the Embedded Signup flow
        if (data.event === 'FINISH' || data.event === 'FINISH_ONLY_WABA') {
          console.log(data);
          const { phone_number_id, waba_id } = data.data;
          changeHandler(WABA_ID_KEY, waba_id);
        } else if (data.event === 'CANCEL') {
          const { current_step } = data.data;
          console.warn('Cancel at ', current_step);
        } else if (data.event === 'ERROR') {
          const { error_message } = data.data;
          console.error('error ', error_message);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    window.addEventListener('message', embeddedSignupInfoListener);

    return () => {
      window.removeEventListener('message', embeddedSignupInfoListener);
    };
  });

  return (
    <div className="WhatsAppChannelForm">
      <Loader isLoading={fetchingWabaId}>
        <TwilioChannelForm {...props} disableForwarding={true} />
        {!props.value.configuration.waba_id && !wabaIdFetchError && (
          <a
            className="btn btn-primary"
            style={{ display: 'block', color: 'white' }}
            disabled={fetchingWabaId}
            onClick={() => {
              window.FB.login(() => {}, {
                config_id: process.env.REACT_APP_WHATSAPP_CONFIG_ID,
                auth_type: 'rerequest', // Avoids 'user is already logged' in errors if users click the button again before refreshing the page
                response_type: 'code',
                override_default_response_type: true,
                extras: {
                  sessionInfoVersion: 3, // Required to get WABA ID
                  featureType: 'only_waba_sharing', // TODO: conditional
                  setup: {
                    solutionID: process.env.REACT_APP_WHATSAPP_SOLUTION_ID,
                  },
                },
              });
            }}
          >
            Connect WhatsApp Business Account
          </a>
        )}
        {props.value.configuration.waba_id && !wabaIdFetchError && (
          <GeckoFields
            fields={[
              {
                label: 'WhatsApp Business Account ID',
                type: GECKO_CONSTS.FIELD_TYPE_TEXT,
                key: 'configuration.waba_id',
                disabled: true,
                required: true,
                width: '100%',
              },
              {
                label: 'WhatsApp Display Name',
                type: GECKO_CONSTS.FIELD_TYPE_TEXT,
                key: 'configuration.waba_display_name',
                description: (
                  <span>
                    Must follow Meta{' '}
                    <a
                      target="_blank"
                      href="https://www.facebook.com/business/help/757569725593362"
                    >
                      guidelines
                    </a>
                  </span>
                ),
                required: true,
                width: '100%',
                disabledWhen: () => !!props.value.configuration.phone_number,
              },
              {
                key: 'value',
                type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
                render: () => {
                  return (
                    <div>
                      <p>
                        <b>
                          For any other WhatsApp business profile updates
                          (image, about, description) contact support.
                        </b>
                      </p>
                    </div>
                  );
                },
                width: '100%',
              },
            ]}
            values={props.value}
            handler={changeHandler}
          />
        )}
      </Loader>
    </div>
  );
};

export default WhatsAppChannelForm;
